import { render, staticRenderFns } from "./RightMain.vue?vue&type=template&id=6f64f967&scoped=true&"
import script from "./RightMain.vue?vue&type=script&lang=js&"
export * from "./RightMain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f64f967",
  null
  
)

export default component.exports